/* B2B PLP behaviors: card qty stepper + AJAX add (opens drawer), quick view,
   add-to-list (shares 'saved-for-later' with the cart), grid/list view toggle
   (persisted), items-per-page. Vanilla JS, delegated listeners, no frameworks. */
/* two sections may emit this same script tag; execute once */
if (!window.__plpB2B) {
  window.__plpB2B = true;

(function () {
  'use strict';

  var VIEW_KEY = 'plp-view';

  function refreshCartUi() {
    /* cart-b2b.js's Section Rendering refresh + drawer open */
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    if (window.publish) window.publish('cart-update', { source: 'plp-card' });
  }

  /* ---- qty stepper + add ---- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      var box = (minus || plus).closest('[data-card-qty]');
      var input = box.querySelector('input');
      var value = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, value + (plus ? 1 : -1));
      return;
    }

    var add = e.target.closest('[data-card-add]');
    if (add && add.hasAttribute('data-variant-id')) {
      e.preventDefault();
      if (add.hasAttribute('data-busy')) return;
      /* the qty stepper lives in the card OR the quick-view panel */
      var card = add.closest('[data-b2b-card], [data-qv-content]');
      var qtyInput = card && card.querySelector('[data-card-qty] input');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      add.setAttribute('data-busy', '');
      var label = add.textContent;
      add.textContent = ((window.b2bStrings || {}).adding || '…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(add.getAttribute('data-variant-id'), 10), quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (item) {
          add.textContent = ((window.b2bStrings || {}).added || 'Added');
          /* remember handles in the cart; the checkout click promotes them to
             'b2b-ordered', which drives the Previously-purchased badge */
          try {
            /* only accumulate history when the badge feature is enabled */
            if (item && item.handle && window.b2bFlags && window.b2bFlags.prevPurchased) {
              var ch = JSON.parse(localStorage.getItem('b2b-cart-handles') || '[]');
              if (ch.indexOf(item.handle) === -1) ch.push(item.handle);
              localStorage.setItem('b2b-cart-handles', JSON.stringify(ch.slice(-60)));
            }
          } catch (err) {}
          refreshCartUi();
          setTimeout(function () {
            add.textContent = label;
            add.removeAttribute('data-busy');
          }, 1200);
        })
        .catch(function () {
          add.textContent = ((window.b2bStrings || {}).tryAgain || 'Try again');
          setTimeout(function () {
            add.textContent = label;
            add.removeAttribute('data-busy');
          }, 1500);
        });
      return;
    }

    var quickView = e.target.closest('[data-quick-view]');
    if (quickView) {
      e.preventDefault();
      /* no modal library: quick view = navigate; kept as a hook for later */
      window.location.href = quickView.getAttribute('data-product-url');
      return;
    }

    var addList = e.target.closest('[data-add-to-list]');
    if (addList) {
      e.preventDefault();
      var saved = [];
      try { saved = JSON.parse(localStorage.getItem('saved-for-later') || '[]'); } catch (err) {}
      var id = addList.getAttribute('data-variant-id');
      if (!saved.some(function (s) { return String(s.variantId) === id; })) {
        saved.push({
          variantId: id,
          title: addList.getAttribute('data-item-title'),
          price: addList.getAttribute('data-item-price'),
          url: addList.getAttribute('data-item-url')
        });
        try { localStorage.setItem('saved-for-later', JSON.stringify(saved)); } catch (err) {}
      }
      var original = addList.textContent;
      addList.textContent = ((window.b2bStrings || {}).saved || 'Saved ✓');
      setTimeout(function () { addList.textContent = original; }, 1500);
      return;
    }

    /* ---- view toggle ---- */
    var viewBtn = e.target.closest('[data-view-toggle]');
    if (viewBtn) {
      var view = viewBtn.getAttribute('data-view-toggle');
      applyView(view);
      try { localStorage.setItem(VIEW_KEY, view); } catch (err) {}
      return;
    }

    /* ---- density toggle ---- */
    var densBtn = e.target.closest('[data-density-toggle]');
    if (densBtn) {
      var dens = densBtn.getAttribute('data-density-toggle');
      applyDensity(dens);
      try { localStorage.setItem('plp-density', dens); } catch (err) {}
    }
  });

  function applyDensity(dens) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    grid.classList.toggle('b2b-grid--dense', dens === 'dense');
    document.querySelectorAll('[data-density-toggle]').forEach(function (b) {
      var active = b.getAttribute('data-density-toggle') === dens;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  try {
    if (localStorage.getItem('plp-density') === 'dense') applyDensity('dense');
  } catch (e) {}

  function applyView(view) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    grid.classList.toggle('b2b-grid--list', view === 'list');
    document.querySelectorAll('[data-view-toggle]').forEach(function (b) {
      var active = b.getAttribute('data-view-toggle') === view;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    grid.querySelectorAll('.b2b-card').forEach(function (c) {
      c.classList.toggle('b2b-card--list', view === 'list');
      c.classList.toggle('b2b-card--grid', view !== 'list');
    });
  }

  /* ---- collection intro "Read more" (button only when clamped) ---- */
  document.querySelectorAll('[data-collection-intro]').forEach(function (intro) {
    var text = intro.querySelector('.collection-intro__text');
    var more = intro.querySelector('[data-intro-more]');
    if (!text || !more) return;
    /* the button is server-rendered (row reserved, no CLS) and only made visible when the text actually overflows */
    if (text.scrollHeight > text.clientHeight + 2) {
      more.removeAttribute('aria-hidden'); more.removeAttribute('tabindex'); more.classList.add('is-shown');
      more.addEventListener('click', function () {
        intro.classList.add('is-expanded');
        more.hidden = true;
      });
    } else {
      intro.classList.add('is-expanded'); /* nothing to clamp: drop the clamp so Chromium cannot paint a phantom ellipsis */
      more.hidden = true;
    }
  });

  /* restore persisted view (grid is default markup) */
  try {
    if (localStorage.getItem(VIEW_KEY) === 'list') applyView('list');
  } catch (e) {}

  /* re-apply after facet AJAX re-renders swap the grid */
  new MutationObserver(function () {
    try {
      if (localStorage.getItem(VIEW_KEY) === 'list') applyView('list');
    } catch (e) {}
  }).observe(document.getElementById('ProductGridContainer') || document.body, { childList: true, subtree: false });

  /* ---- items per page ---- */
  /* server-side via alternate templates: the toolbar select navigates to
     ?view=24 / (default) / ?view=96 so Liquid paginates correctly */
  document.addEventListener('change', function (e) {
    var per = e.target.closest('[data-per-page]');
    if (per) {
      var url = new URL(window.location.href);
      if (per.value === '48') url.searchParams.delete('view');
      else url.searchParams.set('view', per.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });
})();

/* Shared: keep Tab inside an open aria-modal dialog */
if (!window.trapModalFocus) {
  window.trapModalFocus = function (modal) {
    if (modal._trapBound) return;
    modal._trapBound = true;
    /* visible = rendered boxes and no hidden ancestor; offsetParent is null for
       position:fixed elements (the mobile close button) and would drop them */
    var isVisible = function (el) {
      if (el.hidden || el.closest('[hidden]')) return false;
      if (typeof el.checkVisibility === 'function') return el.checkVisibility();
      return el.getClientRects().length > 0;
    };
    var getFocusables = function () {
      return Array.from(modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(isVisible);
    };
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || modal.hidden) return;
      var focusables = getFocusables();
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    /* escape hatch: focus that still leaves the dialog comes straight back */
    modal.addEventListener('focusout', function (e) {
      if (modal.hidden || !e.relatedTarget || modal.contains(e.relatedTarget)) return;
      var focusables = getFocusables();
      if (focusables.length) focusables[0].focus();
    });
  };
}

/* ================= Elite PLP extras ================= */
(function () {
  'use strict';

  /* ---------- custom dropdowns (sort / per-page) ---------- */
  function closeAllSelects(except) {
    document.querySelectorAll('[data-b2b-select]').forEach(function (sel) {
      if (sel === except) return;
      var menu = sel.querySelector('.b2b-select__menu');
      var btn = sel.querySelector('.b2b-select__button');
      if (menu) menu.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.b2b-select__button');
    if (btn) {
      var sel = btn.closest('[data-b2b-select]');
      var menu = sel.querySelector('.b2b-select__menu');
      closeAllSelects(sel);
      menu.hidden = !menu.hidden;
      btn.setAttribute('aria-expanded', menu.hidden ? 'false' : 'true');
      return;
    }
    var opt = e.target.closest('.b2b-select__option');
    if (opt) {
      var wrap = opt.closest('[data-b2b-select]');
      var value = opt.getAttribute('data-value');
      var label = wrap.querySelector('[data-select-label]');
      if (label) label.textContent = opt.textContent.trim();
      wrap.querySelectorAll('.b2b-select__option').forEach(function (o) {
        if (o === opt) o.setAttribute('aria-current', 'true');
        else o.removeAttribute('aria-current');
      });
      wrap.querySelector('.b2b-select__menu').hidden = true;
      wrap.querySelector('.b2b-select__button').setAttribute('aria-expanded', 'false');

      if (value === 'ships-fastest') {
        var grid2 = document.getElementById('product-grid');
        if (grid2) {
          Array.from(grid2.children)
            .sort(function (a, b) {
              var la = parseInt((a.querySelector('[data-b2b-card]') || {}).getAttribute ? a.querySelector('[data-b2b-card]').getAttribute('data-lead') : 99, 10) || 99;
              var lb = parseInt((b.querySelector('[data-b2b-card]') || {}).getAttribute ? b.querySelector('[data-b2b-card]').getAttribute('data-lead') : 99, 10) || 99;
              return la - lb;
            })
            .forEach(function (li) { grid2.appendChild(li); });
        }
        return;
      }
      if (value === 'brand-ascending') {
        /* no native vendor sort: client-side reorder of the loaded page */
        var grid = document.getElementById('product-grid');
        if (grid) {
          Array.from(grid.children)
            .sort(function (a, b) {
              var va = (a.querySelector('.b2b-card__brand') || {}).textContent || '';
              var vb = (b.querySelector('.b2b-card__brand') || {}).textContent || '';
              return va.localeCompare(vb);
            })
            .forEach(function (li) { grid.appendChild(li); });
        }
        return;
      }
      var native = document.querySelector(wrap.getAttribute('data-native'));
      if (native) {
        native.value = value;
        /* facets.js listens for bubbled input on the form; per-page listens for change */
        native.dispatchEvent(new Event('input', { bubbles: true }));
        native.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    if (!e.target.closest('[data-b2b-select]')) closeAllSelects(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllSelects(null);
  });

  /* ---------- compare + bulk select (max 4) ---------- */
  var MAX_COMPARE = 4;
  var bar = document.querySelector('[data-select-bar]');

  function selectedChecks() {
    return Array.from(document.querySelectorAll('[data-compare-check]:checked'));
  }

  function refreshBar() {
    var n = selectedChecks().length;
    if (bar) {
      bar.hidden = n === 0;
      var count = bar.querySelector('[data-select-count]');
      if (count) {
        var template = count.getAttribute('data-count-label') || '[n] selected';
        count.textContent = template.replace('[n]', n);
      }
      var cmp = bar.querySelector('[data-compare-open]');
      if (cmp) cmp.disabled = n < 2;
    }
    var counter = document.querySelector('[data-compare-counter]');
    if (counter) {
      counter.hidden = n === 0;
      var cc = counter.querySelector('[data-compare-count]');
      if (cc) cc.textContent = n;
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-compare-check]')) return;
    if (e.target.checked && selectedChecks().length > MAX_COMPARE) {
      e.target.checked = false;
      return;
    }
    refreshBar();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-select-clear]')) {
      selectedChecks().forEach(function (c) { c.checked = false; });
      refreshBar();
      return;
    }

    if (e.target.closest('[data-bulk-add-selected]')) {
      var btn = e.target.closest('[data-bulk-add-selected]');
      if (btn.hasAttribute('data-busy')) return;
      var items = selectedChecks().map(function (c) {
        return { id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 };
      });
      if (!items.length) return;
      btn.setAttribute('data-busy', '');
      var old = btn.textContent;
      btn.textContent = ((window.b2bStrings || {}).adding || 'Adding…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          btn.textContent = ((window.b2bStrings || {}).added || 'Added');
          setTimeout(function () { btn.textContent = old; btn.removeAttribute('data-busy'); }, 1500);
        })
        .catch(function () {
          btn.textContent = ((window.b2bStrings || {}).tryAgain || 'Try again');
          setTimeout(function () { btn.textContent = old; btn.removeAttribute('data-busy'); }, 1500);
        });
      return;
    }

    if (e.target.closest('[data-compare-open]')) {
      var modal = document.querySelector('[data-compare-modal]');
      var host = modal && modal.querySelector('[data-compare-table]');
      if (!modal || !host) return;
      /* harvest comparison data straight from the selected cards' DOM */
      var cards = selectedChecks().map(function (c) { return c.closest('[data-b2b-card]'); });
      var FIXED = ['brand', 'mpn', 'model', 'price', 'availability'];
      var specNames = [];
      var cardData = cards.map(function (card) {
        var specs = {};
        card.querySelectorAll('.b2b-card__spec-highlights li').forEach(function (li) {
          var name = (li.querySelector('span') || {}).textContent || '';
          name = name.replace(/:$/, '');
          specs[name] = li.textContent.replace(name + ':', '').trim();
          if (specNames.indexOf(name) === -1 && FIXED.indexOf(name.toLowerCase()) === -1) specNames.push(name);
        });
        return {
          title: (card.querySelector('.b2b-card__title-link') || {}).textContent || '',
          url: (card.querySelector('.b2b-card__title-link') || {}).href || '#',
          brand: ((card.querySelector('.b2b-card__brand') || {}).textContent || '').trim(),
          mpn: ((card.querySelector('.b2b-card__mpn') || {}).textContent || '').replace('MPN:', '').trim(),
          price: ((card.querySelector('.b2b-card__price') || {}).textContent || '').trim(),
          ship: ((card.querySelector('.b2b-card__ship') || {}).textContent || '').trim(),
          specs: specs
        };
      });
      var esc = function (t) {
        return String(t).replace(/[&<>"']/g, function (ch) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
      };
      var html = '<table class="plp-compare-table"><thead><tr><th></th>';
      cardData.forEach(function (d) { html += '<th><a class="link" href="' + esc(d.url) + '">' + esc(d.title.trim()) + '</a></th>'; });
      html += '</tr></thead><tbody>';
      [['Brand', 'brand'], ['MPN', 'mpn'], ['Price', 'price'], ['Availability', 'ship']].forEach(function (row) {
        html += '<tr><th scope="row">' + row[0] + '</th>';
        cardData.forEach(function (d) { html += '<td>' + esc(d[row[1]] || '—') + '</td>'; });
        html += '</tr>';
      });
      specNames.forEach(function (name) {
        html += '<tr><th scope="row">' + esc(name) + '</th>';
        cardData.forEach(function (d) { html += '<td>' + esc(d.specs[name] || '—') + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table>';
      host.innerHTML = html;
      modal.hidden = false;
      var closeBtn = modal.querySelector('[data-compare-close]');
      modal._returnFocus = e.target.closest('[data-compare-open]');
      if (closeBtn) closeBtn.focus();
      if (window.trapModalFocus) window.trapModalFocus(modal);
      return;
    }

    var modalEl = document.querySelector('[data-compare-modal]');
    if (modalEl && !modalEl.hidden) {
      if (e.target.closest('[data-compare-close]') || e.target === modalEl) closeCompare(modalEl);
    }
  });

  function closeCompare(modal) {
    modal.hidden = true;
    if (modal._returnFocus) { modal._returnFocus.focus(); modal._returnFocus = null; }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var modal = document.querySelector('[data-compare-modal]');
    if (modal && !modal.hidden) { e.stopPropagation(); closeCompare(modal); }
  }, true);
  refreshBar();

  var gridHost = document.getElementById('ProductGridContainer');
  if (gridHost && 'MutationObserver' in window) {
    new MutationObserver(function () { autoFill(); }).observe(gridHost, { childList: true, subtree: true });
  }
  document.addEventListener('click', function (e) {
    var counter = e.target.closest('[data-compare-counter]');
    if (counter) {
      var open = document.querySelector('[data-compare-open]');
      if (open && !open.disabled) open.click();
    }
  });

  /* ---------- recently viewed strip ---------- */
  var recentWrap = document.querySelector('[data-recently-viewed]');
  if (recentWrap) {
    var recent = [];
    try { recent = JSON.parse(localStorage.getItem('recently-viewed') || '[]'); } catch (e) {}
    var currentHandles = Array.from(document.querySelectorAll('[data-b2b-card]')).map(function (c) {
      return c.getAttribute('data-product-handle');
    });
    recent = recent.filter(function (r) { return currentHandles.indexOf(r.handle) === -1; }).slice(0, 8);
    if (recent.length) {
      var list = recentWrap.querySelector('[data-recently-viewed-list]');
      var esc2 = function (t) {
        return String(t).replace(/[&<>"']/g, function (ch) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
      };
      list.innerHTML = recent.map(function (r) {
        if (String(r.url).indexOf('/') !== 0 || String(r.url).indexOf('//') === 0) return '';
        return '<li><article class="b2b-card b2b-card--grid"><div class="b2b-card__body">' +
          (r.brand ? '<p class="b2b-card__brand">' + esc2(r.brand) + '</p>' : '') +
          '<h3 class="b2b-card__title"><a class="b2b-card__title-link" href="' + esc2(r.url) + '">' + esc2(r.title) + '</a></h3>' +
          '<div class="b2b-card__price-row"><span class="b2b-card__price">' + esc2(r.price || '') + '</span></div>' +
          '</div></article></li>';
      }).join('');
      recentWrap.hidden = false;
    }
  }

  /* ---------- filter rail extras ---------- */
  /* collapse state remembered per facet group */
  document.querySelectorAll('#main-collection-filters details.facets__disclosure-vertical[id], #main-collection-filters details.facets__disclosure[id]').forEach(function (d) {
    var key = 'facet-open-' + d.id.replace(/[^a-zA-Z0-9_-]/g, '');
    try {
      var saved = localStorage.getItem(key);
      if (saved === '0') d.removeAttribute('open');
      if (saved === '1') d.setAttribute('open', '');
    } catch (e) {}
    d.addEventListener('toggle', function () {
      try { localStorage.setItem(key, d.open ? '1' : '0'); } catch (e) {}
    });
  });

  function enhanceFacets() {
    /* search box inside groups with >10 options (e.g. Brand) */
    document.querySelectorAll('#main-collection-filters details').forEach(function (group) {
      var lists = group.querySelectorAll('li');
      if (lists.length > 10 && !group.querySelector('[data-facet-search]')) {
        var box = document.createElement('div');
        box.className = 'facets__search';
        box.innerHTML = '<input type="search" data-facet-search placeholder="' + ((window.b2bStrings || {}).searchOptions || 'Search') + '" aria-label="Search options">';
        var content = group.querySelector('.facets__display, fieldset, ul');
        if (content && content.parentElement) content.parentElement.insertBefore(box, content);
        box.querySelector('input').addEventListener('input', function () {
          var q = this.value.toLowerCase();
          lists.forEach(function (li) {
            li.style.display = li.textContent.toLowerCase().indexOf(q) === -1 ? 'none' : '';
          });
        });
      }
    });

  }
  var facetRail = document.getElementById('main-collection-filters');
  if (facetRail) {
    enhanceFacets();
    new MutationObserver(function () { enhanceFacets(); })
      .observe(facetRail, { childList: true, subtree: true });
  }

  /* ---------- load more (appends the next page's grid items) ---------- */
  var loadMore = function (btn, onDone, silent) {
    if (btn.hasAttribute('data-busy')) return;
    btn.setAttribute('data-busy', '');
    var old = btn.textContent;
    btn.textContent = (window.b2bStrings || {}).adding || '…';
    fetch(btn.href)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = function (root) { if (!root) return null; return root.tagName === 'UL' ? root : root.querySelector('ul.b2b-grid'); }; /* search wraps its <ul> in #product-grid */
        var grid = list(document.getElementById('product-grid'));
        var incoming = list(doc.getElementById('product-grid'));
        if (grid && incoming) {
          incoming.querySelectorAll(':scope > li').forEach(function (li) {
            li.querySelectorAll('img').forEach(function (img) { img.loading = 'lazy'; img.removeAttribute('fetchpriority'); }); /* appended pages are below the fold */
            grid.appendChild(li);
          });
        }
        if (grid) {
          var visibleCount = grid.querySelectorAll(':scope > li:not(.b2b-grid__item--featured) [data-b2b-card]').length;
          ['ProductCountDesktop', 'ProductCount'].forEach(function (id) { /* toolbar + mobile count */
            var countEl = document.getElementById(id); if (!countEl) return;
            var m = countEl.textContent.match(/(\d+)\s*[–-]\s*(\d+)(?=\s*of)/);
            if (m) { var from = parseInt(m[1], 10) || 1; countEl.textContent = countEl.textContent.replace(m[0], m[1] + '–' + (from + visibleCount - 1)); }
          });
        }
        /* the page numbers under the button follow the appended page; the URL too (shareable, back button) */
        var pages = document.querySelector('.plp-load-more__pages');
        var incomingPages = doc.querySelector('.plp-load-more__pages');
        if (pages && incomingPages && !silent) pages.innerHTML = incomingPages.innerHTML; /* silent fills keep the landing page highlighted (URL unchanged) */
        if (!silent) { try { history.replaceState(history.state, '', btn.href); } catch (err) {} } /* only a user click moves the URL */
        var nextBtn = doc.querySelector('[data-load-more]');
        var more = false;
        if (nextBtn) { btn.href = nextBtn.href; btn.textContent = old; btn.removeAttribute('data-busy'); more = true; }
        else { btn.closest('.plp-load-more').remove(); }
        if (onDone) onDone(more);
      })
      .catch(function () { btn.textContent = old; btn.removeAttribute('data-busy'); if (onDone) onDone(false); });
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    loadMore(btn);
  });
  /* fill the page: hidden size siblings (tag size-alt) shrink a server page, so fetch the next page(s)
     until the visible count reaches the page size (max 3 extra fetches); Load more + page numbers advance as usual */
  var autoFill = function () {
    var btn = document.querySelector('[data-load-more]');
    var grid = document.getElementById('product-grid');
    if (!btn || !grid || !btn.dataset.pageSize || btn.hasAttribute('data-autofilled')) return;
    btn.setAttribute('data-autofilled', '');
    var pageSize = parseInt(btn.dataset.pageSize, 10) || 48;
    var target = Math.ceil(pageSize / 2); /* fill only badly short pages (hidden siblings); a page that already shows half or more stays as served */
    var ul = grid.tagName === 'UL' ? grid : grid.querySelector('ul.b2b-grid');
    var count = function () { return grid.querySelectorAll('li:not(.b2b-grid__item--featured) [data-b2b-card]').length; };
    if (count() >= target) return;
    /* reserve the final grid height so the appended rows do not push the page down (CLS) */
    var first = ul && ul.querySelector(':scope > li');
    if (first && ul) {
      var cs = getComputedStyle(ul);
      var gap = parseFloat(cs.rowGap) || 0;
      var cols = Math.max(1, Math.round(ul.clientWidth / first.getBoundingClientRect().width));
      ul.style.minHeight = (Math.ceil(pageSize / cols) * (first.getBoundingClientRect().height + gap)) + 'px';
    }
    var release = function () { if (ul) ul.style.minHeight = ''; };
    var fetches = 0;
    var step = function () {
      if (count() >= target || fetches >= 3 || !document.contains(btn)) { release(); return; }
      fetches += 1;
      loadMore(btn, function (more) { if (more) step(); else release(); }, true);
    };
    step();
  };
  autoFill();

  /* ---------- sub-category tile rail arrows ---------- */
  document.querySelectorAll('[data-tile-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-tiles-track]');
    var prev = rail.querySelector('[data-tiles-prev]');
    var next = rail.querySelector('[data-tiles-next]');
    if (!track || !prev || !next) return;
    function updateArrows() {
      var overflow = track.scrollWidth > track.clientWidth + 4;
      prev.hidden = !overflow || track.scrollLeft <= 4;
      next.hidden = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    var arrowsRaf = null;
    function queueUpdateArrows() {
      if (arrowsRaf) return;
      arrowsRaf = requestAnimationFrame(function () { arrowsRaf = null; updateArrows(); });
    }
    track.addEventListener('scroll', queueUpdateArrows, { passive: true });
    window.addEventListener('resize', queueUpdateArrows, { passive: true });
    updateArrows();
  });

  /* ---------- facet "See more" after 8 options ---------- */
  var SEE_MORE_LIMIT = 8;
  function applySeeMore(scope) {
    (scope || document).querySelectorAll('details.facets__disclosure-vertical .facets__list, details.facets__disclosure .facets__list').forEach(function (list) {
      if (list.hasAttribute('data-see-more-done')) return;
      var items = list.querySelectorAll(':scope > li');
      if (items.length <= SEE_MORE_LIMIT) return;
      list.setAttribute('data-see-more-done', '');
      for (var i = SEE_MORE_LIMIT; i < items.length; i++) items[i].classList.add('facet-over-limit');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'facet-see-more';
      var strings = window.b2bStrings || {};
      var moreLabel = (strings.see_more || 'See more ({n})').replace('{n}', items.length - SEE_MORE_LIMIT);
      btn.textContent = moreLabel;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var expanded = list.classList.toggle('is-see-more-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? (strings.see_less || 'See less') : moreLabel;
      });
      list.parentNode.insertBefore(btn, list.nextSibling);
    });
  }
  applySeeMore();
  var facetsWrapper = document.getElementById('main-collection-filters');
  if (facetsWrapper) {
    new MutationObserver(function () { applySeeMore(facetsWrapper); })
      .observe(facetsWrapper, { childList: true, subtree: true });
  }

  /* ---------- mobile sticky chip bar (appears on scroll) ---------- */
  var mobileBar = document.querySelector('[data-mobile-chip-bar]');
  if (mobileBar && window.matchMedia('(max-width: 749px)').matches) {
    var barTicking = false;
    window.addEventListener('scroll', function () {
      if (barTicking) return;
      barTicking = true;
      requestAnimationFrame(function () {
        /* show once the product grid reaches the header (search grids start high on the page; a fixed 420px missed them) */
        var grid = document.getElementById('product-grid');
        var threshold = grid ? grid.getBoundingClientRect().top + window.scrollY - 120 : 420;
        mobileBar.classList.toggle('is-visible', window.scrollY > Math.min(420, Math.max(80, threshold)));
        /* the compact sticky header keeps its search row on phones: measure the real bottom edge */
        var hdr = document.querySelector('.section-header, .shopify-section-header, #shopify-section-header');
        if (hdr) { var hb = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)); if (hb < 200) mobileBar.style.top = hb + 'px'; }
        barTicking = false;
      });
    }, { passive: true });
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mobile-facets-open]');
    if (!open) return;
    /* the mobile facets drawer (filters + sort) opens via its summary */
    var summary = document.querySelector('.mobile-facets__open-wrapper, .mobile-facets__open');
    if (summary) summary.click();
  });

  /* ---------- Previously-purchased badge (from checkout starts) ---------- */
  try {
    var ordered = JSON.parse(localStorage.getItem('b2b-ordered') || '[]');
    if (ordered.length) {
      document.querySelectorAll('[data-prev-purchased]').forEach(function (badge) {
        var card = badge.closest('[data-b2b-card]');
        if (card && ordered.indexOf(card.getAttribute('data-product-handle')) !== -1) {
          badge.hidden = false;
        }
      });
    }
  } catch (e) {}
  /* checkout click promotes the cart's handles to 'ordered' */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.cart__checkout-button, [name="checkout"]')) return;
    try {
      var ch = JSON.parse(localStorage.getItem('b2b-cart-handles') || '[]');
      var ord = JSON.parse(localStorage.getItem('b2b-ordered') || '[]');
      ch.forEach(function (h) { if (ord.indexOf(h) === -1) ord.push(h); });
      localStorage.setItem('b2b-ordered', JSON.stringify(ord.slice(-120)));
      localStorage.removeItem('b2b-cart-handles');
    } catch (err) {}
  }, true);

  /* ---------- filter group order from the section setting ---------- */
  function orderFacets() {
    var orderAttr = document.querySelector('[data-facet-order]');
    if (!orderAttr) return;
    var wanted = orderAttr.getAttribute('data-facet-order').split(',').map(function (t) { return t.trim().toLowerCase(); });
    var rail = document.getElementById('main-collection-filters');
    var sheet = document.querySelector('#FacetFiltersFormMobile .mobile-facets__main');
    if (rail) orderGroups(rail, 'details.facets__disclosure-vertical, details.facets__disclosure', wanted);
    /* the mobile sheet gets the same merchant order, with Sort by as the first row (big-store sheet) */
    if (sheet) {
      orderGroups(sheet, 'details.mobile-facets__details', wanted);
      var sortRow = sheet.querySelector('.mobile-facets__sort');
      var sortGroup = sortRow && sortRow.closest('.mobile-facets__details');
      var firstGroup = sheet.querySelector('details.mobile-facets__details');
      if (sortGroup && firstGroup && firstGroup !== sortGroup) firstGroup.parentElement.insertBefore(sortGroup, firstGroup);
    }
  }
  function placeGroup(parent, group) {
    /* the mobile sheet ends with its sticky Remove all / Apply footer - groups go above it */
    var footer = parent.querySelector(':scope > .mobile-facets__footer');
    if (footer) parent.insertBefore(group, footer); else parent.appendChild(group);
  }
  function orderGroups(rail, selector, wanted) {
    /* the Category nav is pinned above the filter groups (big-store rail) - it never takes part in the ordering */
    var groups = Array.from(rail.querySelectorAll(selector)).filter(function (g) { return !g.classList.contains('facets__category-nav'); });
    if (!groups.length) return;
    var parent = groups[0].parentElement;
    wanted.forEach(function (name) {
      var match = groups.find(function (g) {
        var sum = g.querySelector('summary');
        return sum && sum.textContent.trim().toLowerCase().indexOf(name) === 0;
      });
      if (match) placeGroup(parent, match);
    });
    groups.forEach(function (g) {
      var sum = g.querySelector('summary');
      var label = sum ? sum.textContent.trim().toLowerCase() : '';
      var listed = wanted.some(function (n) { return label.indexOf(n) === 0; });
      if (!listed) placeGroup(parent, g);
    });
    /* Brand expanded by default unless the shopper collapsed it - desktop rail only: in the
       mobile sheet each group is a slide-in panel, and a pre-opened <details> made the first
       tap close it while the slide-in still fired (blank panel) */
    if (rail.classList.contains('mobile-facets__main')) return;
    var brand = groups.find(function (g) {
      var sum = g.querySelector('summary');
      return sum && sum.textContent.trim().toLowerCase().indexOf('brand') === 0;
    });
    if (brand) {
      var key = 'facet-open-' + brand.id.replace(/[^a-zA-Z0-9_-]/g, '');
      try { if (localStorage.getItem(key) === null) brand.setAttribute('open', ''); } catch (e) {}
    }
  }
  orderFacets();

  /* mobile sort select mirrors the desktop custom labels */
  function relabelMobileSort() {
    var desk = document.querySelector('[data-b2b-select][data-native="#SortBy"]');
    if (!desk) return;
    var labels = {};
    desk.querySelectorAll('.b2b-select__option').forEach(function (o) {
      labels[o.getAttribute('data-value')] = o.textContent.trim();
    });
    document.querySelectorAll('mobile-facets select[name="sort_by"] option, .mobile-facets__sort option').forEach(function (opt) {
      if (labels[opt.value]) opt.textContent = labels[opt.value];
    });
  }
  relabelMobileSort();
})();

/* ================= Quick view ================= */
(function () {
  'use strict';

  var cache = {};
  var modal = null;

  function sectionUrl(productUrl) {
    return productUrl.split('?')[0] + '?section_id=quick-view';
  }

  function fetchPanel(productUrl) {
    var url = sectionUrl(productUrl);
    if (!cache[url]) {
      cache[url] = fetch(url).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).catch(function (err) {
        delete cache[url];
        throw err;
      });
    }
    return cache[url];
  }

  function ensureModal() {
    if (modal) return modal;
    var strings = window.b2bStrings || {};
    modal = document.createElement('div');
    modal.className = 'plp-compare-modal qv-modal';
    modal.setAttribute('data-qv-modal', '');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', strings.quickView || 'Quick view');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="qv-modal__frame">' +
      '<button type="button" class="qv-modal__nav qv-modal__nav--prev" data-qv-nav="-1" aria-label="' + (strings.prevProduct || 'Previous product') + '" hidden>&lsaquo;</button>' +
      '<div class="plp-compare-modal__panel qv-modal__panel">' +
      '<div data-qv-host></div>' +
      '</div>' +
      '<button type="button" class="qv-modal__close" data-qv-close aria-label="' + (strings.close || 'Close') + '">&times;</button>' +
      '<button type="button" class="qv-modal__nav qv-modal__nav--next" data-qv-nav="1" aria-label="' + (strings.nextProduct || 'Next product') + '" hidden>&rsaquo;</button>' +
      '</div>';
    document.body.appendChild(modal);
    return modal;
  }

  var QV_SKELETON =
    '<div class="qv qv--skeleton" aria-hidden="true">' +
    '<div class="qv__media"><div class="qv-skel qv-skel--img"></div></div>' +
    '<div class="qv__info">' +
    '<div class="qv-skel qv-skel--line" style="width:30%"></div>' +
    '<div class="qv-skel qv-skel--line" style="width:85%;height:2rem"></div>' +
    '<div class="qv-skel qv-skel--line" style="width:60%"></div>' +
    '<div class="qv-skel qv-skel--line" style="width:40%;height:1.8rem"></div>' +
    '<div class="qv-skel qv-skel--block"></div>' +
    '<div class="qv-skel qv-skel--line" style="width:100%;height:4.8rem"></div>' +
    '<div class="qv-skel qv-skel--line" style="width:60%;height:4rem"></div>' +
    '</div></div>';

  /* prev/next product across the current page's quick-view triggers. When
     opened from inside a carousel, scope navigation to that carousel's own
     slides only (not every trigger on the page) - falls back to the whole
     page's triggers for PLP grids, which have no carousel ancestor. */
  function qvTriggers(trigger) {
    var scope = (trigger && trigger.closest('[data-carousel]')) || document;
    return Array.prototype.slice.call(scope.querySelectorAll('[data-quick-view]'));
  }

  function updateNav(m, trigger) {
    var list = qvTriggers(trigger);
    var i = list.indexOf(trigger);
    var prev = m.querySelector('[data-qv-nav="-1"]');
    var next = m.querySelector('[data-qv-nav="1"]');
    if (prev) prev.hidden = i <= 0;
    if (next) next.hidden = i === -1 || i >= list.length - 1;
    m._qvIndex = i;
  }

  function closeQv() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    if (modal._returnFocus) { modal._returnFocus.focus(); modal._returnFocus = null; }
  }

  function updateThumbArrows(m) {
    var strip = m.querySelector('[data-qv-thumbs]');
    if (!strip) return;
    var prev = m.querySelector('[data-qv-thumbs-prev]');
    var next = m.querySelector('[data-qv-thumbs-next]');
    var overflow = strip.scrollWidth > strip.clientWidth + 4;
    if (prev) prev.hidden = !overflow || strip.scrollLeft <= 4;
    if (next) next.hidden = !overflow || strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
  }

  function openQv(trigger, productUrl) {
    var m = ensureModal();
    var host = m.querySelector('[data-qv-host]');
    host.innerHTML = QV_SKELETON;
    m.hidden = false;
    if (!m._returnFocus) m._returnFocus = trigger; /* keep origin across prev/next */
    m._qvTrigger = trigger;
    updateNav(m, trigger);
    var closeBtn = m.querySelector('[data-qv-close]');
    if (closeBtn) closeBtn.focus();
    if (window.trapModalFocus) window.trapModalFocus(m);
    fetchPanel(productUrl)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-qv-content]');
        host.innerHTML = '';
        if (content) host.appendChild(content);
        updateThumbArrows(m);
        var strip = m.querySelector('[data-qv-thumbs]');
        if (strip) strip.addEventListener('scroll', function () { updateThumbArrows(m); }, { passive: true });
        if (window.B2BLists) {
          host.querySelectorAll('[data-add-to-list]').forEach(function (b) {
            b.classList.toggle('is-saved', window.B2BLists.isSaved(b.getAttribute('data-variant-id')));
          });
        }
        /* delivery suffix / get-it-by re-render for the injected content */
        if (window.DeliveryZip) window.DeliveryZip.refresh();
      })
      .catch(function () { closeQv(); });
    /* analytics hook */
    try {
      document.dispatchEvent(new CustomEvent('b2b:quick-view', { detail: { url: productUrl } }));
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('custom_quick_view_opened', { productUrl: productUrl });
      }
    } catch (e) {}
  }

  /* prefetch on hover */
  document.addEventListener('mouseover', function (e) {
    var qv = e.target.closest('[data-quick-view]');
    if (qv) fetchPanel(qv.getAttribute('data-product-url')).catch(function () {});
  });

  document.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-quick-view]');
    if (qv) {
      e.preventDefault();
      e.stopPropagation();
      openQv(qv, qv.getAttribute('data-product-url'));
      return;
    }
    if (modal && !modal.hidden) {
      if (e.target.closest('[data-qv-close]') || e.target === modal || e.target.classList.contains('qv-modal__frame')) { closeQv(); return; }
      var nav = e.target.closest('[data-qv-nav]');
      if (nav) {
        var list = qvTriggers(modal._qvTrigger);
        var target = list[(modal._qvIndex || 0) + parseInt(nav.getAttribute('data-qv-nav'), 10)];
        if (target) openQv(target, target.getAttribute('data-product-url'));
        return;
      }
      var tPrev = e.target.closest('[data-qv-thumbs-prev]');
      var tNext = e.target.closest('[data-qv-thumbs-next]');
      if (tPrev || tNext) {
        var strip = modal.querySelector('[data-qv-thumbs]');
        if (strip) strip.scrollBy({ left: tPrev ? -160 : 160, behavior: 'smooth' });
        return;
      }
      var preset = e.target.closest('[data-qv-preset]');
      if (preset) {
        var qtyInput = modal.querySelector('.b2b-card__qty-input');
        if (qtyInput) qtyInput.value = preset.getAttribute('data-qty');
        modal.querySelectorAll('[data-qv-preset]').forEach(function (p) {
          p.classList.toggle('is-active', p === preset);
        });
        return;
      }
      var thumb = e.target.closest('[data-qv-thumb]');
      if (thumb) {
        var main = modal.querySelector('#QvMainImage');
        if (main) {
          /* the original srcset would keep winning over a swapped src */
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = thumb.getAttribute('data-full');
        }
        modal.querySelectorAll('[data-qv-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
          if (t === thumb) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        return;
      }
      var variantBtn = e.target.closest('[data-qv-variant]');
      if (variantBtn) {
        var selLabel = modal.querySelector('[data-qv-selected-option]');
        if (selLabel) selLabel.textContent = variantBtn.textContent.trim();
        modal.querySelectorAll('[data-qv-variant]').forEach(function (v) {
          v.setAttribute('aria-pressed', v === variantBtn ? 'true' : 'false');
          v.classList.toggle('is-active', v === variantBtn);
        });
        var add = modal.querySelector('[data-card-add]');
        if (add) add.setAttribute('data-variant-id', variantBtn.getAttribute('data-variant-id'));
        var price = modal.querySelector('.qv__price-value');
        if (price && variantBtn.getAttribute('data-price')) price.textContent = variantBtn.getAttribute('data-price');
        var list = modal.querySelector('[data-add-to-list]');
        if (list) list.setAttribute('data-variant-id', variantBtn.getAttribute('data-variant-id'));
      }
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) { e.stopPropagation(); closeQv(); }
  }, true);
})();
}

/* ---------- quick-shop chips + price range counts (brief D16-18) ---------- */
(function () {
  var cleanParams = function () { var p = new URL(location.href).searchParams; p.delete('page'); p.delete('view'); return p; };
  var render = function (params) {
    if (window.FacetFiltersForm && typeof FacetFiltersForm.renderPage === 'function') FacetFiltersForm.renderPage(params.toString(), null, true);
    else location.search = params.toString();
  };
  /* a chip adds its one parameter to whatever is already applied; toggling it off removes only that parameter */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-quick-chip]');
    if (!a) return;
    if (a.hasAttribute('data-value-chip')) {
      /* popular-value chip: Shopify's url_to_add / url_to_remove already carries every other active filter */
      e.preventDefault();
      var q = a.getAttribute('href').split('?')[1] || '';
      var vp = new URLSearchParams(q); vp.delete('page');
      render(vp);
      return;
    }
    if (!a.dataset.param) return;
    e.preventDefault();
    var param = a.dataset.param; var p = cleanParams();
    if (a.classList.contains('is-active')) {
      p.delete(param); if (/\.lte$/.test(param)) p.delete(param.replace('.lte', '.gte'));
    } else if (a.dataset.priceLte) {
      p.delete(param.replace('.lte', '.gte')); p.set(param, a.dataset.priceLte);
    } else {
      p.set(param, a.dataset.value || '1');
    }
    render(p);
  });
  var syncChips = function () {
    var p = cleanParams();
    document.querySelectorAll('[data-quick-chip]').forEach(function (a) {
      if (a.hasAttribute('data-value-chip')) return; /* server-rendered state, re-rendered with the grid */
      var gte = parseFloat(p.get((a.dataset.param || '').replace('.lte', '.gte')) || '0') || 0;
      var on = a.dataset.priceLte ? (p.get(a.dataset.param) === a.dataset.priceLte && gte === 0) : p.get(a.dataset.param) === (a.dataset.value || '1');
      a.classList.toggle('is-active', on);
      var x = a.querySelector('[data-chip-x]');
      if (on && !x) { x = document.createElement('span'); x.setAttribute('aria-hidden', 'true'); x.setAttribute('data-chip-x', ''); x.textContent = ' ×'; a.appendChild(x); }
      if (!on && x) x.remove();
    });
  };
  /* counts: one tiny request per range (view=count returns the filtered total), always on top of the other active filters */
  var cache = {};
  var countFor = function (modify) {
    var p = cleanParams(); p.delete('filter.v.price.gte'); p.delete('filter.v.price.lte'); modify(p); p.set('view', 'count');
    var url = location.pathname + '?' + p.toString();
    if (cache[url]) return cache[url];
    cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) { var n = parseInt(String(t).replace(/[^\d]/g, ''), 10); if (isNaN(n)) { delete cache[url]; return null; } return n; }).catch(function () { delete cache[url]; return null; }); /* a failed count retries on the next render */
    return cache[url];
  };
  var loadCounts = function () {
    var chips = document.querySelectorAll('[data-quick-chip][data-price-lte]');
    var presets = document.querySelectorAll('[data-price-preset]');
    if (!chips.length && !presets.length) return;
    /* one request per range (desktop and drawer share the same ranges, the cache dedupes); chips derive from the ranges */
    var ranges = {}; presets.forEach(function (b) { ranges[(b.dataset.min || '0') + '-' + (b.dataset.max || '')] = { lo: parseFloat(b.dataset.min) || 0, hi: b.dataset.max }; });
    if (!presets.length) chips.forEach(function (c) { ranges['0-' + c.dataset.priceLte] = { lo: 0, hi: c.dataset.priceLte }; });
    var results = {};
    Promise.all(Object.keys(ranges).map(function (k) {
      var r = ranges[k];
      return countFor(function (p) { if (r.lo > 0) p.set('filter.v.price.gte', String(r.lo)); if (r.hi) p.set('filter.v.price.lte', String(r.hi)); }).then(function (n) { results[k] = n; });
    })).then(function () {
      presets.forEach(function (b) {
        var n = results[(b.dataset.min || '0') + '-' + (b.dataset.max || '')];
        var li = b.closest('li'); if (li) li.hidden = n === 0 && !b.classList.contains('is-active');
        var span = b.querySelector('.facets__price-preset-count');
        if (n === null || n === undefined) { if (span) span.remove(); return; }
        if (!span) { span = document.createElement('span'); span.className = 'facets__price-preset-count'; b.appendChild(span); }
        span.textContent = ' (' + (n >= 1000 ? '1,000+' : n) + ')';
      });
      chips.forEach(function (c) {
        var lim = parseFloat(c.dataset.priceLte); var sum = 0; var known = false;
        Object.keys(ranges).forEach(function (k) { var r = ranges[k]; if (r.hi && parseFloat(r.hi) <= lim && results[k] !== null && results[k] !== undefined) { sum += results[k]; known = true; } });
        c.hidden = known && sum === 0 && !c.classList.contains('is-active');
      });
    });
  };
  var scheduled = null;
  var schedule = function () { clearTimeout(scheduled); scheduled = setTimeout(function () { syncChips(); loadCounts(); }, 250); };
  if (document.querySelector('[data-quick-chip], [data-price-preset]')) {
    syncChips();
    if ('requestIdleCallback' in window) requestIdleCallback(loadCounts, { timeout: 1500 }); else setTimeout(loadCounts, 400);
  }
  var host = document.getElementById('ProductGridContainer');
  if (host && 'MutationObserver' in window) new MutationObserver(schedule).observe(host, { childList: true });
  window.addEventListener('popstate', schedule);
  /* zero results after filtering: bring the message into view (shared filtered links look like a normal page otherwise) */
  var empty = document.querySelector('.plp-empty:not([hidden])');
  if (empty && /filter\./.test(location.search)) { var y = empty.getBoundingClientRect().top + window.scrollY - 120; if (y > 200) window.scrollTo({ top: y, behavior: 'auto' }); }
  /* search: Shopify renders the generic "no results" page when filters empty the result set; offer the same rescue */
  var tpl = document.querySelector('template[data-filter-empty]');
  var zero = document.querySelector('.search-b2b__empty, .search-zero-results');
  if (tpl && zero && /filter\./.test(location.search)) {
    var p = cleanParams(); var keys = []; p.forEach(function (v, k) { if (/^filter\./.test(k)) keys.push(k); });
    var frag = tpl.content.cloneNode(true);
    var last = frag.querySelector('[data-remove-last]'); var clear = frag.querySelector('[data-clear-filters]');
    var pl = new URLSearchParams(p.toString()); if (keys.length) { var k = keys[keys.length - 1]; pl.delete(k); if (/\.lte$/.test(k)) pl.delete(k.replace('.lte', '.gte')); }
    var pc = new URLSearchParams(); if (p.get('q')) pc.set('q', p.get('q'));
    if (last) last.href = location.pathname + '?' + pl.toString();
    if (clear) clear.href = location.pathname + '?' + pc.toString();
    zero.parentNode.insertBefore(frag, zero); zero.hidden = true;
  }
})();

/* ---------- phone sort bottom sheet (filter brief C18) ---------- */
(function () {
  var sheet = document.querySelector('[data-sort-sheet]');
  if (!sheet) return;
  var opener = null;
  var open = function (btn) {
    opener = btn; sheet.hidden = false;
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    document.documentElement.classList.add('plp-sheet-open');
    var first = sheet.querySelector('.plp-sort-sheet__option.is-active') || sheet.querySelector('.plp-sort-sheet__option');
    if (first) first.focus();
    if (window.trapModalFocus) window.trapModalFocus(sheet);
  };
  var close = function () {
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('plp-sheet-open');
    var back = opener; opener = null;
    setTimeout(function () {
      sheet.hidden = true;
      if (window.removeTrapFocus) window.removeTrapFocus();
      if (back) back.focus();
    }, 200);
  };
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-sort-sheet-open]');
    if (o) { e.preventDefault(); open(o); return; }
    if (e.target.closest('[data-sort-sheet-close]')) { close(); return; }
    var opt = e.target.closest('[data-sort-option]');
    if (!opt || !sheet.contains(opt)) return;
    var value = opt.getAttribute('data-sort-option');
    sheet.querySelectorAll('[data-sort-option]').forEach(function (b) {
      var on = b === opt; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var chk = b.querySelector('.plp-sort-sheet__check'); if (chk && !on) chk.remove();
    });
    var deskOpt = document.querySelector('.b2b-select__option[data-value="' + value + '"]');
    if (deskOpt) {
      deskOpt.click(); /* same path as the desktop dropdown: native sorts submit, brand / ships-fastest reorder the grid */
    } else {
      var native = document.getElementById('SortBy-mobile') || document.getElementById('SortBy');
      if (native) {
        native.value = value;
        native.dispatchEvent(new Event('input', { bubbles: true }));
        native.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sheet.hidden) { e.stopPropagation(); close(); }
  }, true);
})();
